import { PatientInstructionOutputDTO } from '@maiia/model/generated/model/api-patient/api-patient';
import { useQuery } from '@tanstack/react-query';
import { asyncActions, instructionsActions } from '@docavenue/core';
import { useDispatch } from 'react-redux';
import useIsPrescriber from './useIsPrescriber';

type Params = {
  consultationReasonId?: string;
};

const useInstructions = ({ consultationReasonId }: Params) => {
  const dispatch = useDispatch();
  const isPrescriber = useIsPrescriber();
  const scope = isPrescriber === true ? 'pat' : 'pat-public';

  return useQuery<PatientInstructionOutputDTO[]>({
    queryKey: [
      'instructions',
      `consultationReasonId:${consultationReasonId}`,
      `isPrescriber:${scope}`,
    ],
    queryFn: () =>
      asyncActions(
        dispatch,
        instructionsActions.getActions(isPrescriber).getList({
          consultationReasonId,
        }),
      ),
    enabled: !!consultationReasonId,
    staleTime: 0,
  });
};

export default useInstructions;
